export default __webpack_public_path__ + "static/media/line-1-left.e9e25fda.svg";